import token from '@/storage/token.js'
import api from '@/api/index'

export default {
  namespaced: true,
  getters: {
    available_roles (state, getters, rootState, rootGetters) {
      console.log('is_login')
      return state.available_roles
    },
  },
  state: {
    available_roles: [],
  },
  mutations: {
    mutation_available_roles (state, payload) {
      console.log('mutation_available_roles: state=', state, ', payload=', payload)
      state.available_roles = payload
    }
  },
  actions: {
    async fetch_available_roles ({ dispatch, commit, state }) {
      console.log('fetch_available_roles')
      let res = await api.get_roles()

      if (res.success) {
        commit('mutation_available_roles', res.payload)
      }
      else {
        commit('mutation_available_roles', [])
      }
    },
  }
}